import React from "react";
import { Container } from "react-bootstrap";
import "./Third.css";
import { useNavigate } from "react-router-dom";

const Third = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="third-extra-services-section">
        <Container>
          <div className="row cta-card-service-row jump-mt">
            <div className="col-xl-8 col-md-8 col-sm-12 cta-card-service-sec-2-col-1">
              <h3>Hire Developers</h3>
              <p>
                Boost your productivity and supercharge your business with our
                professional team of experts, Now!
              </p>
            </div>
            <div className="col-xl-4 col-md-4 col-sm-12 cta-card-service-sec-2-col-2">
              <div className="cta-button">
                <span
                  className="btn btn-primary"
                  onClick={() => {
                    navigate("/ContactUs");
                  }}
                >
                  Schedule a Call
                </span>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Third;
